
// ==============================================

//        NAV FUNCTIONS

// ==============================================

document.addEventListener('DOMContentLoaded', function(e) {

  var btnBurger       = document.getElementById('btn-burger');
  var btnBurger__icon = document.getElementById('btn-burger__icon');
  var navOverlay      = document.getElementById('nav-overlay');
  var navsWrapper     = document.getElementById('navs-wrapper');

  //        Show / Hide responsive nav
  // ==============================================
  function toggleNavResponsive(e) {
    e.preventDefault();
    document.body.classList.toggle('no-scroll');
    btnBurger__icon.classList.toggle('is-active');
    navOverlay.classList.toggle('is-open');
    navOverlay.classList.add('has-transition');
    navsWrapper.classList.toggle('is-open');
    navsWrapper.classList.add('has-transition');
  }
  btnBurger.addEventListener('click', toggleNavResponsive);
  navOverlay.addEventListener('click', toggleNavResponsive);


  // close responsive menu if still open on large screens
  function checkNavResponsive() {
    // CSS Media Query width == window.innerWidth including scrollbars (NOT document.documentElement.clientWidth)
    if(window.innerWidth >= 1024) closeNavResponsive();
  }
  window.addEventListener('resize', checkNavResponsive);


  // reset button states (remove nav transition when switch to resolution)
  function closeNavResponsive() {
    document.body.classList.remove('no-scroll');
    btnBurger__icon.classList.remove('is-active');
    navOverlay.classList.remove('is-open');
    navOverlay.classList.remove('has-transition');
    navsWrapper.classList.remove('is-open');
    navsWrapper.classList.remove('has-transition');
  }


  //        Hide header when scroll down
  // ==============================================

  var lastScroll = 0;
  var header     = document.getElementById('header');

  function toggleHeaderVisibility() {
    var currentScroll = document.body.scrollTop || document.documentElement.scrollTop;

    // scroll down -> hide  / scroll up -> show
    ( currentScroll > 120 && currentScroll > lastScroll ) ? header.classList.add('is-close') : header.classList.remove('is-close');
    lastScroll = currentScroll;
  }
  window.addEventListener('scroll', toggleHeaderVisibility);


  //        Back to top button
  // ==============================================

  // scroll back to top
  function scrollToTop(e) {
    e.preventDefault();
    $('body,html').animate({ scrollTop : 0 }, 1000, 'easeInOutCubic');
  }
  // document.getElementById('btn-top').addEventListener('click', scrollToTop);

  wow = new WOW({
    offset: 60,
    // mobile: false,
  });
  wow.init();


  //        Config Fancybox lightbox
  // ==============================================
  $('[data-fancybox]').fancybox({
    buttons : [
      'close'
    ],
    animationEffect: 'fade',
    wheel: false

  });

})
